import React__default from 'react';
import { T as ThreadProvider } from './ThreadProvider-cf357120.js';
import ThreadUI from './Thread/components/ThreadUI.js';
import './index-ccef08fe.js';
import './index-6add7940.js';
import './utils/message/getOutgoingMessageState.js';
import './UserProfileContext-f3f446d2.js';
import 'prop-types';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './_rollupPluginBabelHelpers-05128ded.js';
import './Thread/context/types.js';
import '@sendbird/chat';
import './topics-eb548880.js';
import '@sendbird/chat/groupChannel';
import './uuid-717930b4.js';
import '@sendbird/chat/message';
import './consts-fa6ab3c0.js';
import './LocalizationContext-a82461b5.js';
import './stringSet-b60e9529.js';
import './utils-b571dc44.js';
import './index-6420013c.js';
import './Thread/components/ParentMessageInfo.js';
import './RemoveMessageModal-2adc29ce.js';
import './ui/Modal.js';
import 'react-dom';
import './index-a9101009.js';
import './ui/Button.js';
import './ui/Icon.js';
import './ui/IconButton.js';
import './MediaQueryContext-d6110905.js';
import './Thread/components/ParentMessageInfoItem.js';
import './index-579ca9d7.js';
import './ui/ImageRenderer.js';
import './ui/TextButton.js';
import './color-91e43dce.js';
import './ui/EmojiReactions.js';
import './ui/ReactionBadge.js';
import './ui/ReactionButton.js';
import './useLongPress-12280c78.js';
import './utils-e0c7329c.js';
import './ui/ContextMenu.js';
import './ui/SortByRow.js';
import './ui/BottomSheet.js';
import './ui/UserListItem.js';
import './ui/Avatar.js';
import './ui/MutedAvatarOverlay.js';
import './ui/Checkbox.js';
import './ui/UserProfile.js';
import './sendbirdSelectors.js';
import './ui/Tooltip.js';
import './ui/TooltipWrapper.js';
import './Message/context.js';
import './ui/VoiceMessageItemBody.js';
import './ui/ProgressBar.js';
import './VoicePlayer/useVoicePlayer.js';
import './index-fa5b2b8c.js';
import './VoiceRecorder/context.js';
import './ui/PlaybackTime.js';
import './ui/Loader.js';
import './index-a2bb2783.js';
import './index.module-4f1cd64e.js';
import './tokenize-c718324d.js';
import './ui/MentionLabel.js';
import './ui/LinkLabel.js';
import './ChannelProvider-5dcbee7b.js';
import './const-72f012b6.js';
import './compareIds-2e50e905.js';
import './resolvedReplyType-9d00a3db.js';
import './Channel/components/SuggestedMentionList.js';
import './const-3a34a127.js';
import './ui/FileViewer.js';
import './ui/MessageItemMenu.js';
import './types-95cfd227.js';
import './ui/MessageItemReactionMenu.js';
import './ui/MessageInput.js';
import 'dompurify';
import './consts-b4cb83cf.js';
import './consts-7693b8d3.js';
import './consts-9469111b.js';
import './index-86294a68.js';
import './useDirtyGetMentions-dffd4046.js';
import './Thread/components/ThreadHeader.js';
import './Thread/components/ThreadList.js';
import './Thread/components/ThreadListItem.js';
import './ui/DateSeparator.js';
import './index-ac0b2d20.js';
import './index-f879f6ef.js';
import './index-ad50e2c0.js';
import './ui/TextMessageItemBody.js';
import './ui/OGMessageItemBody.js';
import './ui/FileMessageItemBody.js';
import './ui/ThumbnailMessageItemBody.js';
import './ui/UnknownMessageItemBody.js';
import 'date-fns';
import './Thread/components/ThreadMessageInput.js';
import './VoiceMessageInputWrapper-43163d7f.js';
import './VoiceRecorder/useVoiceRecorder.js';
import './index-090cbf21.js';
import './index-2cfab646.js';
var Thread = function Thread(props) {
  var className = props.className,
    channelUrl = props.channelUrl,
    message = props.message,
    onHeaderActionClick = props.onHeaderActionClick,
    onMoveToParentMessage = props.onMoveToParentMessage,
    renderHeader = props.renderHeader,
    renderParentMessageInfo = props.renderParentMessageInfo,
    renderMessage = props.renderMessage,
    renderMessageInput = props.renderMessageInput,
    renderCustomSeparator = props.renderCustomSeparator,
    renderParentMessageInfoPlaceholder = props.renderParentMessageInfoPlaceholder,
    renderThreadListPlaceHolder = props.renderThreadListPlaceHolder,
    renderFileUploadIcon = props.renderFileUploadIcon,
    renderVoiceMessageIcon = props.renderVoiceMessageIcon,
    renderSendMessageIcon = props.renderSendMessageIcon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sendbird-thread ".concat(className)
  }, /*#__PURE__*/React__default.createElement(ThreadProvider, {
    channelUrl: channelUrl,
    message: message,
    onHeaderActionClick: onHeaderActionClick,
    onMoveToParentMessage: onMoveToParentMessage
  }, /*#__PURE__*/React__default.createElement(ThreadUI, {
    renderHeader: renderHeader,
    renderParentMessageInfo: renderParentMessageInfo,
    renderMessage: renderMessage,
    renderMessageInput: renderMessageInput,
    renderCustomSeparator: renderCustomSeparator,
    renderParentMessageInfoPlaceholder: renderParentMessageInfoPlaceholder,
    renderThreadListPlaceHolder: renderThreadListPlaceHolder,
    renderFileUploadIcon: renderFileUploadIcon,
    renderVoiceMessageIcon: renderVoiceMessageIcon,
    renderSendMessageIcon: renderSendMessageIcon
  })));
};
export { Thread as default };